import { ScrollView, View } from 'react-native';
import DefaultScreen from '@components/Global/DefaultScreenView';
import { Text, Title } from '@constants/Themed';
import { useQuery } from '@tanstack/react-query';
import apis from '@api/api';
import Chart from '@components/dataTables/chart';
import React from 'react';
import DataSetChart from '@components/dataTables/Charts/DataSetChart';
import parseByDelimiter from '@utils/parseByDelimiter';
import { AntDesign } from '@expo/vector-icons';
import { ContributionGraph, ProgressChart } from 'react-native-chart-kit';
import CustomDatePicker from './components/customDatePicker';
import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';
import ReportDateModal from './components/ReportDateModal';

const IndividualReportScreen = ({ route, navigation }) => {
  const { id, title } = route.params;
  if (!id) {
    return <DefaultScreen><Text>Invalid Report</Text></DefaultScreen>
  }
  const { status, data, error, isFetching, isLoading, refetch } = useQuery({
    queryKey: ['reportData'],
    queryFn: async () => {
      const data = await apis.getReport(id)
        .then(res => {
          return res.data.data
        });
      return data
    },
    retry: 1,
  })
  const chartConfigs = [
    {
      backgroundColor: '#000000',
      backgroundGradientFrom: '#1E2923',
      backgroundGradientTo: '#08130D',
      color: (opacity = 1) => `rgba(26, 255, 146, ${opacity})`,
      style: {
        borderRadius: 16
      }
    },
    {
      backgroundColor: '#022173',
      backgroundGradientFrom: '#022173',
      backgroundGradientTo: '#1b3fa0',
      color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
      style: {
        borderRadius: 16
      }
    },
    {
      backgroundColor: '#ffffff',
      backgroundGradientFrom: '#ffffff',
      backgroundGradientTo: '#ffffff',
      color: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`
    },
    {
      backgroundColor: '#26872a',
      backgroundGradientFrom: '#43a047',
      backgroundGradientTo: '#66bb6a',
      color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
      style: {
        borderRadius: 16
      }
    },
    {
      backgroundColor: '#000000',
      backgroundGradientFrom: '#000000',
      backgroundGradientTo: '#000000',
      color: (opacity = 1) => `rgba(${255}, ${255}, ${255}, ${opacity})`
    }, {
      backgroundColor: '#0091EA',
      backgroundGradientFrom: '#0091EA',
      backgroundGradientTo: '#0091EA',
      color: (opacity = 1) => `rgba(${255}, ${255}, ${255}, ${opacity})`
    },
    {
      backgroundColor: '#e26a00',
      backgroundGradientFrom: '#fb8c00',
      backgroundGradientTo: '#ffa726',
      color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
      style: {
        borderRadius: 16
      }
    },
    {
      backgroundColor: '#b90602',
      backgroundGradientFrom: '#e53935',
      backgroundGradientTo: '#ef5350',
      color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
      style: {
        borderRadius: 16
      }
    },
    {
      backgroundGradientFromOpacity: 0,
      backgroundGradientToOpacity: 0,
      backgroundColor: 'rgb(90,192,234)',
      backgroundGradientFrom: 'transparent',
      backgroundGradientTo: 'transparent',
      color: (opacity = 1) => `rgba(${0}, ${0}, ${0}, ${opacity})`
    }
  ]

  const contributionData = [
    { date: '2016-01-02', count: 1 },
    { date: '2016-01-03', count: 2 },
    { date: '2016-01-04', count: 3 },
    { date: '2016-01-05', count: 4 },
    { date: '2016-01-06', count: 5 },
    { date: '2016-01-30', count: 2 },
    { date: '2016-01-31', count: 3 },
    { date: '2016-03-01', count: 2 },
    { date: '2016-04-02', count: 4 },
    { date: '2016-03-05', count: 2 },
    { date: '2016-02-30', count: 4 }
  ]

  return (
    <>
    <DefaultScreen scrollDisabled inverseSearch containerStyle={{ paddingTop: 20 }} screenTitle={title ? title : 'blank'} noMargin backButton searchBar={{ showSearch: false, inverse: true, 
      customIcons: [
        { function: () => console.log('something'), functionName: 'sendEmail', icon: <AntDesign name="export" size={24} color="black" /> },
        { function: () => console.log('something'), functionName: 'sendEmail', icon: <AntDesign name="share-alt" size={24} color="black" /> }
      ], 
      extraComponents: (<View><Text style={{ fontWeight: 'bold' }}>{parseByDelimiter(title)}</Text></View>) }}>
      <View style={{ flex: 1, paddingTop: 10}}>
        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ gap: 20, paddingBottom: 150 }} style={{ flex: 1, paddingVertical: 15, gap: 40 }}>
          <View style={{ flex: 1, height: 300 }}>
            <Chart chartTitle={"Entries"} />
          </View>
          <View style={{ flex: 1, height: 300 }}>
            <DataSetChart height={250} data={undefined} />
          </View>
          <View style={{ flex: 1, height: 300 }}>
              <ProgressChart
              width={300}
              height={220}
              strokeWidth={16}
              radius={32}
              chartConfig={chartConfigs[1]}
              hideLegend={false} data={{ labels: ["Swim", "Bike", "Run"], data: [0.4, 0.6, 0.8] }} />
          </View>
          <View style={{ flex: 1, height: 300 }}>
            <ContributionGraph
              width={300}
              height={220}
              chartConfig={chartConfigs[8]}
              endDate={new Date('2023-05-01')}
              numDays={365}
              style={{ backgroundColor: 'rgb(90,192,234)', borderRadius: 20 }}
              values={[
                { date: '2023-01-02', count: 1 },
                { date: '2023-01-03', count: 2 },
                { date: '2023-01-04', count: 3 },
                { date: '2023-01-05', count: 4 },
                { date: '2023-01-06', count: 5 },
                { date: '2023-01-30', count: 2 },
                { date: '2023-01-31', count: 3 },
                { date: '2023-03-01', count: 2 },
                { date: '2023-04-02', count: 4 },
                { date: '2023-03-05', count: 2 },
                { date: '2023-02-30', count: 4 }
              ]} />
          </View>
        </ScrollView>
      </View>
    </DefaultScreen>
      <BottomSheetModalProvider>
        <ReportDateModal/>
      </BottomSheetModalProvider>
    </>
  )
}
export default IndividualReportScreen